const ALPHA_TOKEN = /[Xx]/;
const DIGIT_TOKEN = "0";

const escapeRegExp = (char) => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Translates a "masked.format" string (X = alpha, 0 = digit, anything else = literal)
// into PrimeReact InputMask syntax (a = alpha, 9 = digit, anything else = literal).
export const buildPrimeMask = (format) => {
    if (!format) return "";
    return format.split("").map((char) => {
        if (ALPHA_TOKEN.test(char)) return "a";
        if (char === DIGIT_TOKEN) return "9";
        return char;
    }).join("");
};

// Builds a RegExp that a completed value must exactly match for the given format.
export const buildMaskRegex = (format) => {
    if (!format) return null;
    const pattern = format.split("").map((char) => {
        if (ALPHA_TOKEN.test(char)) return "[A-Za-z]";
        if (char === DIGIT_TOKEN) return "[0-9]";
        return escapeRegExp(char);
    }).join("");
    return new RegExp(`^${pattern}$`);
};

// Re-inserts a format's literal separators into a value that already has the
// right characters but not the right separators (e.g. a value fetched from an
// API before this field was masked, or saved back without separators).
// Only touches values whose alpha/digit content exactly fills every slot -
// mid-typing values are always left untouched, since PrimeReact's InputMask
// already keeps separators in sync as the user types.
export const reformatToMask = (rawValue, format) => {
    if (rawValue === undefined || rawValue === null || rawValue === "" || !format) return rawValue ?? "";

    const raw = String(rawValue);
    const regex = buildMaskRegex(format);
    if (regex.test(raw)) return raw;

    const slots = format.split("").filter((char) => char === DIGIT_TOKEN || ALPHA_TOKEN.test(char));
    const content = raw.replace(/[^a-zA-Z0-9]/g, "");
    if (content.length !== slots.length) return raw;

    let contentIndex = 0;
    let result = "";
    for (const token of format) {
        if (token === DIGIT_TOKEN) {
            if (!/[0-9]/.test(content[contentIndex])) return raw;
            result += content[contentIndex++];
        } else if (ALPHA_TOKEN.test(token)) {
            if (!/[A-Za-z]/.test(content[contentIndex])) return raw;
            result += content[contentIndex++];
        } else {
            result += token;
        }
    }
    return result;
};
